import * as React from 'react';
import TableComponentV2, { KeyHeader } from '../../../shared/TableComponentV2';
import { ChatBarChartComponent } from './ChatBarChartComponent';
import { ChatLineChartComponent } from './ChatLineChartComponent';
import { ChatPieChartComponent } from './ChatPieChartComponent';


// export enum ChartType = "LineChart" | "PieChart" | "BarChart" | "table"

export enum ChatChartType {
    LINE_CHART = "LineChart",
    PIE_CHART = "PieChart",
    BAR_CHART = "BarChart",
    BAR_CHART_2 = "bar_chart",
    LINE_CHART_2 = "line_chart",
    PIE_CHART_2 = "pie_chart",
    TABLE = "table"
}

// Chart data structure
export interface ChatChartData {

        meta?: {
            chart_type: ChatChartType
            title?: string
            xAxis?: {
                data_key: string
                dataKey: string
                name: string
            },
            x_axis?: {
                dataKey: string
                data_key: string
                name: string
            }
            x_axis_label?: string
            y_axis_label?: string

            yAxis?: {
                dataKey: string
                data_key: string
                name: string
            },
            bars?: {
                dataKey: string
                data_key: string
                name: string
            }[],
            y_axis?: {
                dataKey: string
                data_key: string
                name: string
            }
            lines?: {dataKey?: string,data_key?: string, name: string, stroke?: string}[]
            margin?: {
                top: number
                right: number
                left: number
                bottom: number
            }
            nameKey?: string
            name_key?: string
            valueKey?: string
            value_key?: string

        }
        data: Record<string, any>[]

}

// Colors for the charts
export const CHART_COLORS = [
    "hsl(var(--chart-1))",
    "hsl(var(--chart-2))",
    "hsl(var(--chart-3))",
    "hsl(var(--chart-4))",
    "hsl(var(--chart-5))",
    "#8884d8",
    "#82ca9d",
    "#ffc658",
    "#ff8042",
    "#0088fe",
]



type Props = {
    chartData: ChatChartData
    type: ChatChartType
};
const ChatChartComponent = ({chartData, type}: Props) => {


    const { data } = chartData

    switch (type) {
        case ChatChartType.BAR_CHART:
        case ChatChartType.BAR_CHART_2:
            return <ChatBarChartComponent chartData={chartData}/>
        case ChatChartType.LINE_CHART:
        case ChatChartType.LINE_CHART_2:
            return <ChatLineChartComponent chartData={chartData}/>;
        case ChatChartType.PIE_CHART:
        case ChatChartType.PIE_CHART_2:
            return <ChatPieChartComponent chartData={chartData}/>;
        default:
            return <TableComponentV2
                header={Object.keys(data[0]).map(item => {
                    return {
                        type: KeyHeader.KEY,
                        key: item,
                        label: item,
                    }
                })}
                items={data}
            />
    }
};

export default ChatChartComponent;